// CardBody.tsx
import React from 'react';

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

const CardBody = ({ children, className = '' }: CardBodyProps) => (
  <div className={`overflow-hidden ${className}`}>
    {children}
  </div>
);

export default CardBody;
